"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentCard = ContentCard;
exports["default"] = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _links = require("../../fuse-link/src/links");
var _picture = require("../../fuse-picture/src/picture");
var _styledContentCard = require("./styled-content-card");
var _excluded = ["aspectRatio", "body", "className", "dataAnalyticsId", "dataAnalyticsIdSecondary", "dataTestId", "headerTag", "heading", "image", "isLazy", "legalText", "link", "removeMargin", "secondaryLink", "videoPlayerSlot"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  aspectRatio: '1:1',
  body: undefined,
  className: 'fuse-content-card',
  dataTestId: 'fuse-content-card-test-id',
  dataAnalyticsId: undefined,
  dataAnalyticsIdSecondary: undefined,
  headerTag: 'h3',
  heading: undefined,
  isLazy: true,
  legalText: undefined,
  link: {
    href: undefined,
    text: undefined
  },
  removeMargin: false,
  secondaryLink: {
    href: undefined,
    text: undefined
  },
  image: {
    fallbackSource: undefined,
    sources: undefined,
    alt: undefined
  },
  videoPlayerSlot: undefined
};
var displayName = 'ContentCard';
var propTypes = {
  aspectRatio: _propTypes["default"].oneOf(['1:1', '16:9', '4:3', '5:4', '3:4']),
  body: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataAnalyticsIdSecondary: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  headerTag: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    fallbackSource: _propTypes["default"].string,
    sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      srcSet: _propTypes["default"].string,
      type: _propTypes["default"].string
    })),
    alt: _propTypes["default"].string
  }),
  isLazy: _propTypes["default"].bool,
  legalText: _propTypes["default"].string,
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  removeMargin: _propTypes["default"].bool,
  secondaryLink: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  videoPlayerSlot: _propTypes["default"].node
};
function ContentCard(_ref) {
  var aspectRatio = _ref.aspectRatio,
    body = _ref.body,
    className = _ref.className,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataAnalyticsIdSecondary = _ref.dataAnalyticsIdSecondary,
    dataTestId = _ref.dataTestId,
    headerTag = _ref.headerTag,
    heading = _ref.heading,
    image = _ref.image,
    isLazy = _ref.isLazy,
    legalText = _ref.legalText,
    link = _ref.link,
    removeMargin = _ref.removeMargin,
    secondaryLink = _ref.secondaryLink,
    videoPlayerSlot = _ref.videoPlayerSlot,
    props = _objectWithoutProperties(_ref, _excluded);
  var activePrimaryLink = link.href;
  var activePrimaryLinkAndText = link.href && link.text;
  var activeSecondaryLinkAndText = secondaryLink.href && secondaryLink.text;
  var activeVideo = videoPlayerSlot;
  return /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledContentCard, _extends({
    className: className,
    as: !activePrimaryLink || activeVideo ? 'div' : activeSecondaryLinkAndText && 'div',
    "data-analyticsid": activePrimaryLink && !activeSecondaryLinkAndText && dataAnalyticsId,
    "data-testid": dataTestId,
    href: activePrimaryLink && !activeSecondaryLinkAndText && !activeVideo && link.href,
    removeMargin: removeMargin
  }, props), videoPlayerSlot && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledVideoWrapper, null, videoPlayerSlot), image && !videoPlayerSlot && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledImageWrapper, {
    aspectRatio: aspectRatio
  }, /*#__PURE__*/_react["default"].createElement(_picture.Picture, _extends({}, image, {
    isLazy: isLazy
  }))), heading && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledHeading, {
    body: body,
    type: "heading",
    tag: headerTag,
    size: {
      xxs: '1',
      s: '2',
      l: '3'
    }
  }, heading), body && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledBody, {
    type: "paragraph",
    size: "1"
  }, body), activePrimaryLinkAndText && !activeSecondaryLinkAndText && !activeVideo && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledSpanLink, _extends({}, link, {
    iconRight: true,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null)
  }), link.text), activePrimaryLinkAndText && (activeSecondaryLinkAndText || activeVideo) && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledLinksWrapper, null, /*#__PURE__*/_react["default"].createElement(_links.Link, _extends({}, link, {
    className: "fuse-content-card__primary-link",
    "data-testid": "fuse-content-card-primary-link-test-id",
    href: link.href,
    iconRight: true,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    "data-analyticsid": dataAnalyticsId
  }), link.text), activeSecondaryLinkAndText && /*#__PURE__*/_react["default"].createElement(_links.Link, _extends({}, secondaryLink, {
    className: "fuse-content-card__secondary-link",
    "data-testid": "fuse-content-card-secondary-link-test-id",
    href: secondaryLink.href,
    iconRight: true,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    "data-analyticsid": dataAnalyticsIdSecondary
  }), secondaryLink.text)), legalText && /*#__PURE__*/_react["default"].createElement(_styledContentCard.StyledLegalText, {
    type: "paragraph",
    size: {
      xxs: 'm2'
    }
  }, legalText));
}
ContentCard.propTypes = propTypes;
ContentCard.displayName = displayName;
ContentCard.defaultProps = defaultProps;
var _default = exports["default"] = ContentCard;